module.exports = __webpack_public_path__ + "static/media/map.6190c728.svg";